module.exports = __webpack_public_path__ + "img/HomeScreenshot-1250h.ab57d758.png";